export default __webpack_public_path__ + "static/media/icon-marketing.1889820b.svg";